const AUTH_FEEDBACK_MINIMUM_MS = 2500;

/** Keep authentication feedback visible without adding time to slower requests.
 * Rejections observe the same minimum before the caller presents its error. */
export async function withAuthFeedbackDelay<T>(operation: () => Promise<T>): Promise<T> {
  const [outcome] = await Promise.allSettled([
    operation(),
    new Promise<void>(resolve => window.setTimeout(resolve, AUTH_FEEDBACK_MINIMUM_MS)),
  ]);
  if (outcome.status === "rejected") throw outcome.reason;
  return outcome.value;
}
